<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import { getClientName } from "@/utils/client";

export default {
  name: "App",
  created() {
    document.title = getClientName() === "bonitas" ? "Bonitas SHE" : "Health Risk Assessment";
  },
};
</script>

<style lang="scss">


</style>
